import React from "react";

const SectionLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center p-10 bg-white/60 backdrop-blur-sm rounded-xl">
      <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-red-500 to-red-600 rounded-xl animate-pulse shadow-md">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          className="w-5 h-5"
        >
          <circle cx="12" cy="12" r="3" />
          <circle cx="12" cy="1" r="1" />
          <circle cx="12" cy="23" r="1" />
          <circle cx="20.49" cy="8.5" r="1" />
          <circle cx="3.51" cy="15.5" r="1" />
          <circle cx="20.49" cy="15.5" r="1" />
          <circle cx="3.51" cy="8.5" r="1" />
        </svg>
      </div>

      <h1 className="mt-3 text-lg font-semibold text-gray-700">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">
          Loading...
        </span>
      </h1>

      <div className="mt-3 flex space-x-1">
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-bounce [animation-delay:-0.3s]"></span>
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-bounce [animation-delay:-0.15s]"></span>
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-bounce"></span>
      </div>
    </div>
  );
};

export default SectionLoader;
